<template>
  <div>
    <status-module
      :appointment="appointment"
      class="mb-2"
      data-cy="statusModule"
    />
    <service-category-module
      :appointment="appointment"
      class="mb-2"
      data-cy="serviceCategoryModule"
    />
    <technician-module
      v-if="isMultiTechEnabled"
      :appointment="appointment"
      class="mb-2"
      data-cy="technicianModule"
    />
    <read-only-module>
      <template #header>
        <div>
          <b>These Fields are Only Editable in Pending Status</b>
        </div>
      </template>
      <template #body>
        <div>
          <detail-label
            label="Duration:"
            :value="durationDisplay"
            class="mb-2"
          />
          <detail-label
            label="Estimated Remaining:"
            :value="remainingDurationLabel(remainingMinutes)"
            :class="['mb-2', { 'text-danger': remainingMinutes < 0 }]"
          />
          <detail-label
            v-if="!isMultiTechEnabled"
            label="Technician:"
            :value="technicianLabelValue"
            class="mb-2"
          />
          <detail-label label="Scheduled:" :value="scheduledLabelValue" />
        </div>
      </template>
    </read-only-module>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useFeatureFlag } from "@/lib/useFeatureFlag";

import DetailLabel from "@/components/DetailLabel.vue";
import {
  assignedTechnicianLabel,
  calculateRemainingDuration,
  durationLabel,
  remainingDurationLabel,
  scheduledDateTime
} from "@/mixins";
import ReadOnlyModule from "../modules/ReadOnlyModule.vue";
import ServiceCategoryModule from "../modules/ServiceCategory/ServiceCategoryModule.vue";
import StatusModule from "../modules/Status/StatusModule.vue";
import TechnicianModule from "../modules/Technician/TechnicianModule.vue";

const props = defineProps<{
  appointment: Record<string, any>;
}>();

const isMultiTechEnabled = useFeatureFlag("multiple_technicians_ff_enabled");

const scheduledLabelValue = computed(() =>
  scheduledDateTime(
    props.appointment.scheduled_time,
    props.appointment.arrival_window_start,
    props.appointment.arrival_window_end
  )
);

const technicianLabelValue = computed(() => {
  const { technician, assignment_pinned, pinned_reason } = props.appointment;
  return assignedTechnicianLabel(technician, assignment_pinned, pinned_reason);
});

const remainingMinutes = computed(() =>
  calculateRemainingDuration(props.appointment)
);

const durationDisplay = computed(() =>
  durationLabel(
    props.appointment.duration_minutes ||
      props.appointment.estimated_duration_minutes,
    props.appointment.service_category
  )
);
</script>
